module.exports = __webpack_public_path__ + "media/icons/ic_mission-757482f8.svg";